import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=0ea2c21d&scoped=true"
import script from "./Buyer.vue?vue&type=script&lang=js"
export * from "./Buyer.vue?vue&type=script&lang=js"
import style0 from "./Buyer.vue?vue&type=style&index=0&id=0ea2c21d&prod&lang=css"
import style1 from "./Buyer.vue?vue&type=style&index=1&id=0ea2c21d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2c21d",
  null
  
)

export default component.exports